import React from 'react'
import { FormattedMessage } from 'react-intl'
import { ProductData } from 'lib/types'
import { ListPages } from 'lib/core/services/gtm'
import { Alert, EmptyContainer, FadeIn, Spinner } from 'lib/ui'
import { ProductCard } from 'components/ProductCard'
import { Container, NoItems } from './styled'

interface Props {
  products?: ProductData[]
  isLoading: boolean
  isFetching: boolean
  isError?: boolean
  listPage: ListPages
  clearFiltersHandler?: () => void
}

export const ProductList = ({ products, isError, isFetching, isLoading, listPage, clearFiltersHandler }: Props) => {
  const hasItems = Boolean(products?.length)
  const showSpinner = isLoading || (!hasItems && isFetching)

  return (
    <>
      {showSpinner ? (
        <EmptyContainer>
          <FadeIn>
            <Spinner />
          </FadeIn>
        </EmptyContainer>
      ) : (
        <>
          {isError ? (
            <EmptyContainer>
              <Alert>
                <FormattedMessage
                  id='app.whoops'
                />
              </Alert>
            </EmptyContainer>
          ) : (
            <>
              {hasItems ? (
                <FadeIn>
                  <Container isFetching={isFetching}>
                    {products?.map(product => {
                      const { id } = product
                      return (
                        <ProductCard
                          key={id}
                          product={product}
                          listPage={listPage}
                        />
                      )
                    })}
                  </Container>
                </FadeIn>
              ) : (
                <NoItems>
                  <FormattedMessage
                    id='catalog.productList.emptyState'
                  />
                  {clearFiltersHandler && (
                    <button type='button' onClick={clearFiltersHandler}>
                      <FormattedMessage
                        id='catalog.productList.action.clearFilters'
                      />
                    </button>
                  )}
                </NoItems>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}
